export default __webpack_public_path__ + "static/media/unf1.0250847b.jpg";